import { render, staticRenderFns } from "./OrganizationChart.vue?vue&type=template&id=318e0592&scoped=true"
import script from "./OrganizationChart.vue?vue&type=script&lang=js"
export * from "./OrganizationChart.vue?vue&type=script&lang=js"
import style0 from "./OrganizationChart.vue?vue&type=style&index=0&id=318e0592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e0592",
  null
  
)

export default component.exports